import React, { ReactElement } from 'react'
import { Td, Tr } from '@chakra-ui/react'
import { TTableRowData, IRenderTableRowArgs } from './types'

export function TableRow<T extends TTableRowData>({
  row,
}: IRenderTableRowArgs<T>): ReactElement {
  return (
    <Tr {...row.getRowProps()} as="div" display="flex" role="row">
      {row.cells.map((cell) => (
        <Td
          {...cell.getCellProps()}
          as="div"
          fontSize="md"
          key={cell.column.id}
          maxW={cell.column.maxWidth}
          role="cell"
          w={cell.column.width}>
          {cell.render('Cell')}
        </Td>
      ))}
    </Tr>
  )
}
